module.exports = __webpack_public_path__ + "img/placeholder-thumbnail-profile-user.b1281ead.png";